// import {createApp} from 'vue'
// import App from './App.vue'
// import router from './router'
// import store from './store'
//
//
// // 导入项目的主样式文件
// import('@/assets/css/main.css')
//
// // 导入 ElementPlus UI 库
// import ElementPlus from 'element-plus'
//
// // 导入 ElementPlus 的中文语言包
// import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
//
// // 导入 ElementPlus 的组件样式
// import 'element-plus/dist/index.css'
//
// // 导入 ElementPlus 的所有图标
// import * as ElementPlusIconsVue from '@element-plus/icons-vue'
//
//
// const app = createApp(App)
// {
//     app.use(store)
//     app.use(router)
//     app.mount('#app')
//     app.use(ElementPlus, {
//         locale: zhCn,
//     })
//     for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
//         app.component(key, component)
//     }
// }

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 导入项目的主样式文件
import('@/assets/css/main.css')

// 导入 ElementPlus UI 库
import ElementPlus from 'element-plus'

// 导入 ElementPlus 的中文语言包
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'

// 导入 ElementPlus 的组件样式
import 'element-plus/dist/index.css'

// 导入 ElementPlus 的所有图标
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

// 创建 Vue 应用实例
const app = createApp(App)

store.dispatch('initStore')


app.use(store)
app.use(router)
app.use(ElementPlus, {
    locale: zhCn,
})


for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}


app.mount('#app')
